import { styled } from "@mui/material";
import Grid from "@mui/material/Grid";
import ReadonlyFeeScheduleCategoriesTable from "_shared/fee-schedules/categories/_views/readonly-fee-schedule-categories-table";
import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { FeeScheduleCategoryMaskedCurrency, Masked } from "work/masked-fields";
import Proposal from "work/proposals/proposal";
import { MaskedProposalField, maskedProposalFieldNotice } from "work/proposals/_views/_shared/masked-field-notice";

const ListContainer = styled(Grid)(({ theme }) => ({
  height: "100%",
  marginTop: theme.spacing(-3),
  minHeight: "20rem",
}));
const CategorySelection = styled(ReadonlyFeeScheduleCategoriesTable)(() => ({
  height: "100%",
}));

type FeeScheduleTabProps = {
  proposal: Proposal;
};

export default function FeeScheduleTab(props: Readonly<FeeScheduleTabProps>) {
  const { proposal } = props;

  const selectedCategories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[] = Masked.isPresentNotMasked(proposal.feeSchedule) ? proposal.feeSchedule : [];


  if (Masked.isMasked(proposal.feeSchedule)) {
    return maskedProposalFieldNotice(MaskedProposalField.FeeSchedule);
  }

  return (
    <ListContainer container direction="row">
      <Grid size="grow">
        <CategorySelection categories={selectedCategories} />
      </Grid>
    </ListContainer>
  );
}
